import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import SHA256 from 'crypto-js/sha256';
// @todo use crypto-hash once our Node version/bundler supports 16/18+ syntax
const sha256 = (input: string) => SHA256(input).toString();
export const persistedQueriesLink = createPersistedQueryLink({
  sha256,
});
